<script>
import { mapActions } from 'vuex';
export default {
    computed: {
        hookData() {
            return this.$store.getters['customer/getHookData']('emailCaptured');
        },
    },

    created() {
        this.addHook({
            hook: 'emailCaptured',
            name: 'identifyCustomerWithHeap',
            callback: this.sendToHeap,
        });
    },

    methods: {
        ...mapActions('customer', ['addHook']),

        sendToHeap() {
            return new Promise(async (resolve) => {
                await this.$services.heap.identify(this.hookData.email);

                resolve();
            });
        },
    },

    render() {},
};
</script>
